import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Toggleable } from "../../../hook/useToggle";
import { IValueInfoInput } from "../../../types/valuelist";
import BusyButton from "../../common/busy-button";
import { AddIcon, CloseIcon } from "../../common/icons";
import useValueListApi from "./useValueListApi";
import ValueEditForm from "./value-edit-form";

const NewValueModal = (props: Toggleable) => {
  const { isOpen, toggle } = props;

  const { createValueInfo, busy } = useValueListApi();

  const handleSubmit = (input: IValueInfoInput) => createValueInfo(input)
    .then(ok => ok && toggle());

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg" scrollable autoFocus={false}>
      <ModalHeader toggle={toggle} tag={'h2'}>Create New Value</ModalHeader>
      <ModalBody className="p-4">
        <ValueEditForm id="value_create_form" onSubmit={handleSubmit} autoFocus={true} />
      </ModalBody>
      <ModalFooter>
        <BusyButton type="submit" form="value_create_form" color="primary"
          value="Create" busy={busy}>
          <AddIcon />
        </BusyButton>

        <Button color="secondary" onClick={toggle} disabled={busy}>
          <CloseIcon /> Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewValueModal;
